module.exports = __webpack_public_path__ + "static/media/logo-g0v-white.8b001a4d.svg";